<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Unités</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Liste des Unités</h3>
        <div class="card-options d-flex gap-2">
          <button class="btn btn-outline-success btn-sm" @click="showCreateUnitModal">
            <i class="fe fe-plus-circle me-1"></i> Ajouter
          </button>
          <button class="btn btn-outline-info btn-sm" @click="exportCSV">
            <i class="fe fe-download me-1"></i> Exporter
          </button>
        </div>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="units"
            @edit="onEdit"
            @delete="onDelete"
        >
          <template #cell-code="{ item }">
            <strong>{{ item.code }}</strong>
          </template>
          <template #cell-label="{ item }">
            {{ item.label }}
          </template>
        </TableWithFilters>
      </div>
    </div>

    <!-- Modal de création -->
    <modal-create-unit
        :unit="selectedUnit"
        @refresh="loadUnits"
    />
  </div>
</template>

<script>
  import ModalCreateUnit from "../../../components/modals/ModalCreateUnit.vue";
  import TableWithFilters from "../../../components/TableWithFilters.vue";
  import {
    unitColumns,
    unitFilterableFields,
    unitRowActions,
  } from "../../../helpers/constants";
  import {confirmAction, showValidationErrors} from "../../../helpers/helpers";
  import {API} from "../../../helpers/api-endpoints";

  export default {
    name: "Units",
    components: {
      TableWithFilters,
      ModalCreateUnit,
    },
    data() {
      return {
        units: [],
        selectedUnit: null,
        columns: unitColumns,
        filterableFields: unitFilterableFields,
        rowActions: unitRowActions,
      };
    },
    methods: {
      showCreateUnitModal() {
        this.selectedUnit = null;
        $('#modal-create-unit').modal('show');
      },
      loadUnits() {
        this.$loading(true);
        this.$http
            .get("/registry/units")
            .then(({ data }) => {
              this.units = data;
            })
            .catch((err) => {
              console.error("Erreur lors du chargement des unités :", err);
            })
            .finally(() => this.$loading(false));
      },
      onEdit(item) {
        this.selectedUnit = { ...item };
        $('#modal-create-unit').modal('show');
      },
      async onDelete(item) {
        try {
          const { confirmed } = await confirmAction("delete");
          if (!confirmed) return;

          this.$loading(true);
          await this.$http.delete(API.REGISTRY_UNIT_DELETE(item.id)); //
          this.$toast.success("Unité supprimée avec succès !");
          await this.loadUnits();
        } catch (err) {
          console.error("Erreur suppression Unité :", err);
          showValidationErrors(err);
          this.$toast.error("Impossible de supprimer l'Unité.");
        } finally {
          this.$loading(false);
        }
      },
      exportCSV() {
        const headers = this.columns.map(col => col.label);
        const rows = this.units.map(row =>
            this.columns.map(col => `"${row[col.key] ?? ''}"`).join(",")
        );
        const csvContent = [headers.join(","), ...rows].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "unites.csv");
        link.click();
        URL.revokeObjectURL(url);
      },
    },
    mounted() {
      this.loadUnits();
    },
  };
</script>
